import { Check, Mail, Phone, IdCard, Share2, Landmark, Banknote, Home } from "lucide-react";

const ITEMS = [
  { key: "email", label: "Email", icon: Mail },
  { key: "phone", label: "Phone", icon: Phone },
  { key: "identity", label: "Identity", icon: IdCard },
  { key: "socials", label: "Socials", icon: Share2 },
  { key: "address", label: "Address", icon: Home },
  { key: "tax", label: "Tax details", icon: Landmark },
  { key: "bank", label: "Bank", icon: Banknote },
];

export default function VerificationBadges({ verifications = {}, compact = false, onVerify }) {
  if (compact) {
    return (
      <div className="flex flex-wrap gap-1.5" data-testid="verification-badges">
        {ITEMS.filter((i) => verifications[i.key]).map((i) => {
          const Icon = i.icon;
          return (
            <span
              key={i.key}
              title={`${i.label} verified`}
              className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full bg-nexus-blue/10 text-nexus-blue border border-nexus-blue/30"
            >
              <Icon className="h-3 w-3" />
              {i.label}
            </span>
          );
        })}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid="verification-list">
      {ITEMS.map((i) => {
        const Icon = i.icon;
        const done = !!verifications[i.key];
        return (
          <button
            key={i.key}
            type="button"
            disabled={done || !onVerify}
            onClick={() => onVerify?.(i.key)}
            data-testid={`verify-${i.key}-btn`}
            className={`flex items-center justify-between p-3 rounded-lg border transition-colors ${
              done
                ? "bg-nexus-purple/10 border-nexus-purple/30 cursor-default"
                : "bg-white/[0.02] border-white/10 hover:border-white/25 cursor-pointer"
            }`}
          >
            <div className="flex items-center gap-3">
              <Icon className={`h-4 w-4 ${done ? "text-nexus-purple" : "text-zinc-400"}`} />
              <span className="text-sm text-white">{i.label}</span>
            </div>
            {done ? (
              <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-nexus-purple font-bold">
                <Check className="h-3 w-3" /> Verified
              </span>
            ) : (
              <span className="text-[10px] uppercase tracking-widest text-zinc-500">Verify</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
